import wx from 'weixin-js-sdk'

export default async function initWeixinShare(params) {
    if (!global.isWeiXin) {
          return
    }
    let res = await global.http.post('loginAndRegister/getWxconfig', { url: params.link });
    if (res.errcode === 0) {
          const { appid, noncestr, signature, timestamp } = res.result;
          console.log(appid, noncestr, signature, timestamp)
          //注册组件
          wx.config({
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: appid, // 必填，公众号的唯一标识
                timestamp: timestamp, // 必填，生成签名的时间戳
                nonceStr: noncestr, // 必填，生成签名的随机串
                signature: signature,// 必填，签名
                jsApiList: ["updateAppMessageShareData", "updateTimelineShareData", "onMenuShareTimeline", "onMenuShareAppMessage", "onMenuShareQQ"] // 必填，需要使用的JS接口列表
          });
          wx.ready(function () {
                console.log('ready004')
                wx.onMenuShareAppMessage(params)
                wx.onMenuShareTimeline(params)
                wx.onMenuShareQQ(params);
                wx.onMenuShareQZone(params);
          })
    } else {
          console.log(res.errmsg)
    }

}